import React from 'react'
import s from './Tile.module.scss'

export const Tile = ({color, size, fontSize, width, ...props}) => {
    return <p onClick={props.onClick} style={{fontSize: fontSize || '1em', width: width}} className={`${s.tile} ${s[color]} ${s[size]} ${props.className} text-center mb-0 trunc`}> {props.children} </p>
}